import SofiaProRegular from 'assets/fonts/SofiaProRegular.woff2';
import SofiaProSemiBold from 'assets/fonts/SofiaProSemiBold.woff2';

export const HYPERLINK_MODAL_ID = 'hyperlink-modal';
export const SNIPPET_MODAL_ID = 'snippet-modal';
export const TOKEN_HTML_TAG = 'editor-token';
export const FONT_STYLES = `
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProRegular}) format('woff2');
    font-weight: 400; /* normal */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProSemiBold}) format('woff2');
    font-weight: 600; /* "semi-bold" */
  }
`;
export const HANDLEBAR_TOKEN_DATA_ATTR = 'data-handlebar';
export const DCB_CUSTOM_TEXT_TOKENS_PREVIEW_FLAG = 'dcb-tokens';
